import { render, staticRenderFns } from "./guiaIndicadores.vue?vue&type=template&id=45348368&"
import script from "./guiaIndicadores.vue?vue&type=script&lang=js&"
export * from "./guiaIndicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports